export const mailingContent = () => {
    return [
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            scopedSlots: {
                customRender: 'operation'
            }
        },
        {
            title: '邮寄说明',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: '是否邮寄',
            dataIndex: 'number',
            key: 'number',
            scopedSlots: {
                customRender: 'number'
            }
        },
        {
            title: '是否扫描',
            dataIndex: 'scanningFlag',
            key: 'scanningFlag',
            scopedSlots: {
                customRender: 'scanningFlag'
            }
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark'
        }
    ]
}
